import useAnimationScreenStore from "stores/animationScreenStore";
import { AnimationScreenParams } from "types/animationScreen";

const AnimationScreenBridge = {
    show: async (id: string, payload?: AnimationScreenParams) => {
        return useAnimationScreenStore.getState().show(id, payload);
    },
    stop: (id: string) => {
        useAnimationScreenStore.getState().stop(id);
    },
    hide: (id: string) => {
        useAnimationScreenStore.getState().hide(id);
    },
};

export default AnimationScreenBridge;